jQuery(document).ready(function(){
jQuery('.product-single__thumbnail').click(function(){
	jQuery('.product-single__thumbnail').removeClass('active');
	jQuery(this).addClass('active');
});
  jQuery('.description-review-title a').click();
});

/** catch add to cart **/
const open = window.XMLHttpRequest.prototype.open;

function openReplacement() {
  this.addEventListener("load", function () {
    if (
      [
        "/cart/add.js",
        "/cart/update.js",
        "/cart/change.js",
        "/cart/clear.js",
      ].includes(this._url)
    ) {
      calculateShipping(this.response);
    }
  });
  return open.apply(this, arguments);
}

window.XMLHttpRequest.prototype.open = openReplacement;

function calculateShipping(cartJson) {
//  console.log("calculate new shipping");
//  console.log(JSON.parse(cartJson));
    const gotocheckout = '<div class="theme-button product-cart-button" id="goto-checkout"><a href="https://cieffe.store/checkout">Procedi al Pagamento</a>'
    $('.template-product #AddToCartText').text("Procedi al pagamento");
    $('.template-product #AddToCart').remove();
    $( ".shopify-payment-button" ).before( gotocheckout );

}